/**
 * Format a duration in milliseconds as `"<h>h <m>m"`.
 *
 * Positive deltas: `"1h 48m"`, `"0h 15m"`, `"23h 59m"`.
 * Zero: `"0h 0m"`.
 * Negative deltas render with a leading minus sign (e.g. `"-1h 30m"`).
 * Minutes are floored; seconds are discarded.
 */

const MS_PER_MINUTE = 60 * 1000;
const MINUTES_PER_HOUR = 60;

export const formatDuration = (deltaMs: number): string => {
    if (!Number.isFinite(deltaMs)) {
        return "0h 0m";
    }

    const sign = deltaMs < 0 ? "-" : "";
    const totalMinutes = Math.floor(Math.abs(deltaMs) / MS_PER_MINUTE);
    const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
    const minutes = totalMinutes % MINUTES_PER_HOUR;

    return `${sign}${hours}h ${minutes}m`;
};
